// @core/api/endpoints/secret/generate_random_bytes.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GenerateRandomBytesRequest,
  GenerateRandomBytesResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Generate random bytes
 * Generates cryptographically secure random bytes. Output format is base64 or hex.
 */
export async function GenerateRandomBytes(
  engine_id: string,
  data: GenerateRandomBytesRequest,
  options?: RequestOptions
): Promise<GenerateRandomBytesResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/transit/random`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  const requestOptions = options;
  return client.post<GenerateRandomBytesResponse>(requestPath, data, requestOptions);
}
